<template>
  <div class="contact">
    <header>
      <HeaderWhite/>
    </header>
    <main>
      <ContactItems/>
    </main>
    <footer class="footer">
      <Footer/>
    </footer>
  </div>
</template>

<script>
import HeaderWhite from '../components/common/HeaderWhite.vue'
import Footer from '../components/common/Footer'
import ContactItems from '../components/contact/ContactItems.vue'

export default {
  // name: 'contact',
  components: {
    HeaderWhite,
    Footer,
    ContactItems
  }
}
</script>
<style scoped>
.contact {
  height: 100vh;
  width: 100vw;
}
.footer {
  position: absolute;
  bottom:0;
}
</style>